<ul class="menu">
  @for (category of categories(); track category.i; let i = $index) {
    <li
      class="menu-item"
      (mouseover)="onCatalogItemMouseOver()"
      >
      <div class="menu-link-container">
        <a
          class="menu-link g-main-link menu-link-{{i}}"
          [routerLink]="['/', category.s]"
          routerLinkWithLang
        >
          {{ category.n }}
        </a>
        @if (category.c.length) {
          <i class="mbi mbi-ios-arrow-right menu-hover-arrow menu-hover-arrow-{{i}}"></i>
        }
      </div>
    </li>
  }
</ul>
